<template>
  <div>
    <v-form v-model="isFormValid">
      <div class="d-flex justify-space-between">
        <h2>小口現金出納帳</h2>
        <v-spacer />
        <v-btn
          :to="`/cashbook/${yearMonth}`"
          target="_blank"
          :disabled="!yearMonth || isLoading"
          color="primary"
          variant="outlined"
          class="mr-2"
        >
          <v-icon start>mdi-tray-arrow-down</v-icon>
          ダウンロード
        </v-btn>
        <v-btn
          @click="accountTitleDialog = true"
          :disabled="isLoading"
          color="primary"
          variant="flat"
        >
          <v-icon start>mdi-plus</v-icon>
          勘定科目
        </v-btn>
      </div>

      <v-card variant="flat" class="mt-6 pa-2" color="grey-lighten-5">
        <v-container>
          <v-row>
            <v-col cols="4">
              <h5>年</h5>
              <v-text-field
                v-model="searchFilter.year"
                variant="outlined"
                density="compact"
                hide-details
                type="number"
                :disabled="isLoading"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <h5>月</h5>
              <v-select
                v-model="searchFilter.month"
                :items="monthItems"
                variant="outlined"
                density="compact"
                hide-details
                :disabled="isLoading"
              ></v-select>
            </v-col>
            <v-col cols="2" align-self="end">
              <v-btn
                @click="listCashbook"
                :disabled="isLoading"
                color="primary"
                variant="flat"
                :loading="isLoading"
                >検索</v-btn
              >
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-container>
      </v-card>

      <v-container class="mx-2 mt-4">
        <v-row>
          <v-col cols="3">
            <v-select
              v-model="isFinalized"
              :items="finalizeItems"
              filled
              hide-details
              density="compact"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="my-4" fluid>
        <v-row>
          <v-col cols="10" style="overflow-x: scroll">
            <v-table fixed-header style="min-width: 78vw">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>日付</th>
                    <th>科目</th>
                    <th>摘要</th>
                    <th>購入先</th>
                    <th>収入</th>
                    <th>支出</th>
                    <th>残高</th>
                    <th>税区</th>
                    <th>備考</th>
                    <th>削除</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>引出</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field
                        v-if="cashbook && cashbook.carriedAmount != null"
                        v-model="cashbook.carriedAmount"
                        type="number"
                        :rules="[isNotMinus]"
                        class="font-small"
                        variant="outlined"
                        density="compact"
                        hide-details=""
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td>
                      <v-text-field
                        :value="cashbook ? cashbook.carriedAmount : 0"
                        class="font-small"
                        variant="outlined"
                        filled
                        density="compact"
                        readonly
                        hide-details=""
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, i) in details" :key="item.detailId">
                    <td class="font-small">{{ i + 1 }}</td>
                    <td class="width-small">
                      <v-select
                        :value="getDayfromDate(item.date)"
                        @change="item.date = getDatefromDay($event)"
                        :items="dayItems"
                        class="font-small"
                        variant="outlined"
                        hide-details=""
                        density="compact"
                        append-icon=""
                      ></v-select>
                    </td>
                    <td>
                      <v-select
                        :value="item.title ? item.title.titleId : ''"
                        @change="item.titleId = $event"
                        :items="accountTitleList"
                        item-title="name"
                        item-value="titleId"
                        class="font-small"
                        variant="outlined"
                        hide-details=""
                        density="compact"
                        append-icon=""
                        small-chips
                      ></v-select>
                    </td>
                    <td>
                      <v-text-field
                        class="font-small"
                        variant="outlined"
                        hide-details
                        density="compact"
                        v-model="item.description"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        class="font-small"
                        variant="outlined"
                        hide-details
                        density="compact"
                        v-model="item.supplier"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        class="font-small"
                        variant="outlined"
                        hide-details
                        density="compact"
                        :rules="[isNotMinus]"
                        type="number"
                        v-model="item.incomeAmount"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        class="font-small"
                        variant="outlined"
                        hide-details
                        density="compact"
                        type="number"
                        :rules="[isNotMinus]"
                        v-model="item.outgoAmount"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        class="font-small"
                        variant="outlined"
                        filled
                        hide-details=""
                        density="compact"
                        readonly
                        :value="item.incomeAmount - item.outgoAmount"
                      ></v-text-field>
                    </td>
                    <td class="width-small">
                      <v-select
                        class="font-small"
                        variant="outlined"
                        hide-details
                        density="compact"
                        chips
                        small-chips
                        append-icon=""
                        :items="taxationOptions"
                        item-title="title"
                        item-value="value"
                        v-model="item.taxation"
                      ></v-select>
                    </td>
                    <td>
                      <v-text-field
                        class="font-small"
                        variant="outlined"
                        hide-details=""
                        density="compact"
                        v-model="item.note"
                      ></v-text-field>
                    </td>
                    <td>
                      <!-- <v-checkbox density="compact" hide-details=""></v-checkbox> -->
                      <v-btn
                        @click="
                          deleteRow({
                            detailId: item.detailId,
                          })
                        "
                        small
                        dark
                        color="grey"
                        variant="flat"
                        >削除</v-btn
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>合計</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field
                        :value="cashbook ? cashbook.totalIncomeAmount : 0"
                        class="font-small"
                        variant="outlined"
                        filled
                        density="compact"
                        readonly
                        hide-details
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        :value="cashbook ? cashbook.totalOutgoAmount : 0"
                        class="font-small"
                        variant="outlined"
                        filled
                        density="compact"
                        readonly
                        hide-details
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        :value="cashbook ? cashbook.remainingAmount : 0"
                        class="font-small"
                        variant="outlined"
                        filled
                        density="compact"
                        readonly
                        hide-details
                      ></v-text-field>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </template>
            </v-table>

            <div class="ma-4">
              <v-btn @click="addDetailRow" color="primary" variant="outlined" small>
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-col>

          <!-- 勘定科目テーブル -->
          <v-col cols="2" style="overflow-x: scroll">
            <v-table fixed-header density="compact" style="min-width: 15vw">
              <thead>
                <tr>
                  <th>科目</th>
                  <th>収入集計</th>
                  <th>支出集計</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in accountTitleList" :key="i">
                  <td>{{ item.name }}</td>
                  <td>{{ getIncomebyAccountTitle(item.titleId) }}</td>
                  <td>{{ getOutgobyAccountTitle(item.titleId) }}</td>
                  <td>
                    <v-btn
                      @click="deleteAccountTitle(item.titleId)"
                      color="error"
                      x-small
                      variant="outlined"
                      >削除</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <div class="mt-8">
      <div class="d-flex my-3" v-if="cashbook && cashbook.attachments">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              添付ファイルリスト
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card
                v-for="(item, i) in cashbook.attachments"
                :key="i"
                class="ma-1"
                variant="outlined"
              >
                <v-card-text class="pa-5 d-flex align-center">
                  <v-icon start>mdi-file-document-outline</v-icon>
                  {{ item.filename }}
                  <v-spacer />
                  <v-btn
                    :href="item.attachmentUrl"
                    target="_blank"
                    color="primary"
                    icon
                  >
                    <!-- <v-icon>mdi-magnify</v-icon> -->
                    <v-icon>mdi-tray-arrow-down</v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="d-flex my-4">
        <v-file-input
          v-model="file"
          :disabled="isLoading"
          variant="outlined"
          density="compact"
          placeholder="ファイルを選択"
          @change="addAttachmentFile"
        >
        </v-file-input>
      </div>
    </div>

    <div class="my-12 d-flex justify-center">
      <v-btn
        @click="clickSave"
        :disabled="cashbook == null || isLoading || !isFormValid"
        color="primary"
        class="mx-4"
        variant="flat"
        large
        >保存</v-btn
      >
    </div>

    <!-- dialog -->
    <v-dialog v-model="accountTitleDialog" max-width="600px">
      <v-card>
        <v-card-title>勘定科目</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" align-self="center"> 科目名 </v-col>
              <v-col cols="6" align-self="center">
                <v-text-field
                  v-model="accountTitleName"
                  variant="outlined"
                  density="compact"
                  hide-details=""
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-btn @click="accountTitleDialog = false" color="grey" text
                >キャンセル</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn @click="createAccountTitle" color="primary" variant="flat"
                >追加</v-btn
              >
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- sample -->
    <!-- <div v-html="html"></div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { cashbookModule } from "@/store/dataModules/cashbookModule";
import LocalDataService from "@/service/LocalDataService";
import ValidationMixin from "@/mixins/ValidationMixin";
import {
  AccountTitleResponse,
  CashbookDetailsResponse,
  CashbookResponse,
} from "chaild-api/lib";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { meModule } from "@/store/dataModules/meModule";
import ApiResource from "@/api/ApiResource";

export default defineComponent({
  name: "CashBook",

  mixins: [ValidationMixin],

  async mounted() {
    await this.listCashbook();
    await this.listAccountTitle();
  },

  data() {
    return {
      html: "" as any,
      isLoading: false,
      isFormValid: true,
      accountTitleDialog: false,
      taxationOptions: [
        { title: "", value: "" },
        { title: "通常課税", value: "normal" },
        { title: "課税軽減", value: "reduced" },
        { title: "非課税", value: "none" },
      ],
      finalizeItems: [
        { title: "入力中", value: false },
        { title: "確定", value: true },
      ],
      monthItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      isFinalized: false,
      accountTitleName: "",
      searchFilter: {
        year: dayjs().year(),
        month: dayjs().month() + 1,
      },
      file: null as File | null,
      attachments: [] as string[],
    };
  },

  computed: {
    yearMonth: function (): string {
      let _month = String(this.searchFilter.month);
      if (this.searchFilter.month < 10) {
        _month = "0" + this.searchFilter.month;
      }
      return String(this.searchFilter.year) + "-" + _month;
    },
    // cashbook: function(): CashbookResponse | null {
    // return cashbookModule.cashbook;
    // },
    cashbook: {
      get(): CashbookResponse | null {
        return cashbookModule.cashbook;
      },
      set(value: CashbookResponse) {
        cashbookModule.setCashbook(value);
      },
    },
    details: function (): CashbookDetailsResponse[] {
      if (cashbookModule.cashbook) {
        return cashbookModule.cashbook.details;
      } else {
        return [];
      }
    },
    accountTitleList: function (): AccountTitleResponse[] {
      return cashbookModule.accountTitleList;
    },
    dayItems: function (): string[] {
      const items: string[] = [];
      for (let i = 1; i < 32; i++) {
        if (i < 10) {
          items.push("0" + String(i));
        } else {
          items.push(String(i));
        }
      }
      return items;
    },
  },

  methods: {
    async clickSave() {
      if (this.checkAuthority()) {
        // 確定中から入力中に戻す場合
        if (this.cashbook?.finalizedAt && !this.isFinalized) {
          await this.updateCashbook();
          await this.updateCashbookDetail();
        } else {
          await this.updateCashbookDetail();
          await this.updateCashbook();
        }
        await this.listCashbook();
      } else {
        alert("施設長のみ入力中/確定の変更が可能です");
      }
    },
    async listCashbook() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await cashbookModule.listCashbook({
          nurseryId: nurseryId,
          yearMonth: this.yearMonth,
        });
        // 確定中
        if (
          cashbookModule.cashbook &&
          cashbookModule.cashbook.finalizedAt != null
        ) {
          this.isFinalized = true;
        } else {
          this.isFinalized = false;
        }

        // attachments
        if (this.cashbook && this.cashbook.attachments) {
          this.attachments = this.cashbook.attachments.map((a) => a.objectKey);
        }
      }
      this.isLoading = false;
    },
    async listAccountTitle() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await cashbookModule.listAccountTitle({
          nurseryId,
        });
      }
      this.isLoading = false;
    },
    async createAccountTitle() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await cashbookModule.createAccountTitle({
          nurseryId: nurseryId,
          name: this.accountTitleName,
        });
        await this.listAccountTitle();
      }
      this.accountTitleDialog = false;
    },
    async addDetailRow() {
      this.isLoading = true;
      await this.updateCashbookDetail();
      // carriedAmount
      let _carriedAmount: number | null = null;
      if (
        cashbookModule &&
        cashbookModule.cashbook &&
        cashbookModule.cashbook.carriedAmount != null
      ) {
        _carriedAmount = cashbookModule.cashbook.carriedAmount;
      }

      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await cashbookModule
          .createCashbookDetail({
            nurseryId,
            yearMonth: this.yearMonth,
            details: [{ day: "01" }],
          })
          .catch(() => {
            this.isLoading = false;
          });
        await this.listCashbook();

        // carriedAmount
        if (_carriedAmount && cashbookModule.cashbook) {
          cashbookModule.cashbook.carriedAmount = _carriedAmount;
        }
      }
      this.isLoading = false;
    },
    async updateCashbook() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.cashbook && this.cashbook.carriedAmount != null) {
        const response = await cashbookModule
          .updateCashbook({
            nurseryId,
            yearMonth: this.yearMonth,
            isFinalized: this.isFinalized,
            carriedAmount: this.cashbook.carriedAmount,
            attachments: this.attachments,
          })
          .catch(() => (this.isLoading = false));
        if (response) {
          Swal.fire({
            toast: true,
            icon: "success",
            title: "保存しました",
            position: "top-right",
          });
        } else {
          // Swal.fire({
          //   icon: 'error',
          //   title: '保存に失敗しました',
          //   text: '施設長のみ入力中/確定の変更が可能です'
          // });
        }
      }
      this.isLoading = false;
    },
    async updateCashbookDetail() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (
        nurseryId &&
        cashbookModule.cashbook &&
        cashbookModule.cashbook.details
      ) {
        await cashbookModule
          .updateCashbookDetail({
            nurseryId,
            yearMonth: this.yearMonth,
            details: cashbookModule.cashbook.details.map((d) => {
              return {
                day: d.date ? d.date.split("-")[2] : "01",
                detailId: d.detailId,
                description: d.description || undefined,
                supplier: d.supplier || undefined,
                incomeAmount: d.incomeAmount || undefined,
                outgoAmount: d.outgoAmount || undefined,
                taxation: d.taxation || undefined,
                note: d.note || undefined,
                titleId: (d as any).titleId || undefined,
              };
            }),
          })
          .catch(() => (this.isLoading = false));
        // await this.listCashbook();
      }
      this.isLoading = false;
    },
    async deleteRow(input: { detailId: number }) {
      this.isLoading = true;
      const date = this.cashbook?.yearMonth;
      const nurseryId = LocalDataService.getNurseryId();
      const tempArray: number[] = [];
      if (nurseryId && input.detailId && date) {
        tempArray.push(input.detailId);
        const response = await cashbookModule.deleteCashbookDetails({
          nurseryId,
          yearMonth: date,
          detailIds: tempArray,
        });
        if (response) {
          Swal.fire({
            title: "削除しました",
            toast: true,
          });
          this.listCashbook();
        }
      }
      this.isLoading = false;
    },
    getDayfromDate(date: string): string {
      if (date) {
        return dayjs(date).format("DD");
      } else {
        return "01";
      }
    },
    getDatefromDay(day: string): string {
      if (day) {
        return `${this.searchFilter.year}-${this.searchFilter.month}-${day}`;
      } else {
        return "";
      }
    },
    getIncomebyAccountTitle(titleId: number): number {
      let total = 0;
      if (this.cashbook) {
        for (const amount of this.cashbook.details) {
          if (amount.title && amount.title.titleId == titleId) {
            total += amount.incomeAmount;
          }
        }
      }
      return total;
    },
    getOutgobyAccountTitle(titleId: number): number {
      let total = 0;
      if (this.cashbook) {
        for (const amount of this.cashbook.details) {
          if (amount.title && amount.title.titleId == titleId) {
            total += amount.outgoAmount;
          }
        }
      }
      return total;
    },
    checkAuthority(): boolean {
      const nurseryId = LocalDataService.getNurseryId();
      if (!this.isFinalized) {
        if (
          cashbookModule.cashbook &&
          cashbookModule.cashbook.finalizedAt != null &&
          cashbookModule.cashbook.finalizedAt != undefined &&
          meModule.me &&
          nurseryId
        ) {
          const nursery = meModule.me.nurserySchools.find((u) => {
            if (nurseryId == u.nurseryId) {
              return u;
            }
          });
          if (nursery && nursery.isDirector) {
            return true;
          } else {
            return false;
          }
        }
      }
      return true;
    },
    async addAttachmentFile() {
      this.isLoading = true;

      this.attachments = [];
      const objectKey = await this.getFileObjectKey();
      if (objectKey && this.cashbook) {
        // 既存の添付ファイルをarrayにpush
        for (const attachment of this.cashbook.attachments) {
          this.attachments.push(attachment.objectKey);
        }
        // 新規ファイルをarrayにpush
        this.attachments.push(objectKey);

        if (this.checkAuthority()) {
          await this.updateCashbook();
          await this.listCashbook();
        }
      }
      this.file = null;
      this.isLoading = false;
    },
    async getFileObjectKey(): Promise<string> {
      const nurseryId = LocalDataService.getNurseryId();
      if (this.file && nurseryId) {
        const presignedResponse = await ApiResource.getPresignedUrlForCashbook({
          nurseryId: String(nurseryId),
          filename: this.file.name,
        }).catch();
        if (presignedResponse) {
          const uploadResponse = await ApiResource.uploadFile({
            url: presignedResponse.uploadUrl,
            file: this.file,
          });
          if (uploadResponse) {
            return presignedResponse.objectKey as string;
          }
        }
      }
      return "";
    },
    async deleteAccountTitle(titleId: string) {
      if (titleId) {
        const answer = confirm("削除しますか？");
        if (answer) {
          this.isLoading = true;
          const response = await cashbookModule
            .deleteAccountTitle({
              titleId,
            })
            .catch(() => (this.isLoading = false));
          if (response) {
            alert("削除しました");
            await this.listAccountTitle();
          }
          this.isLoading = false;
        }
      }
    },
  },
});
</script>

<style scoped>
.font-small {
  font-size: 0.8rem !important;
}
th,
td {
  padding: 0px 6px !important;
}
.width-small {
  width: 8%;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
